const num = (v) => Number(v) || 0;

export function toProjectStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return {
    labels: rows.map((s) => s.status),
    counts: rows.map((s) => num(s.count)),
  };
}

export function toBudgetSeries(projects) {
  const rows = Array.isArray(projects) ? projects : [];
  return {
    labels: rows.map((p) => p.name),
    budget: rows.map((p) => num(p.budget)),
    actual: rows.map((p) => num(p.actual)),
  };
}

export function toTaskStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return {
    labels: rows.map((s) => s.status),
    counts: rows.map((s) => num(s.count)),
  };
}
